import { SupabaseClient } from '@supabase/supabase-js';
import { storeAuth, getStoredAuth, clearAllData } from './storage';

export function storeCredentials(email: string, password: string) {
  storeAuth(email, password);
}

export async function autoLogin(supabase: SupabaseClient) {
  try {
    const auth = getStoredAuth();
    if (!auth) return false;

    const { data: { user }, error } = await supabase.auth.signInWithPassword({ 
      email: auth.email, 
      password: auth.password 
    });

    if (error || !user) {
      console.error("Autologin failed:", error);
      clearCredentials();
      return false;
    }
    
    return true;
  } catch (error) {
    console.error("Error during autologin:", error);
    clearCredentials();
    return false;
  }
}

export async function refreshSession(supabase: SupabaseClient) {
  try {
    const { data: { session }, error } = await supabase.auth.refreshSession();
    if (error || !session) {
      console.error("Session refresh failed:", error);
      return null;
    }
    return session;
  } catch (error) {
    console.error("Error refreshing session:", error);
    return null;
  }
}

export function clearCredentials() {
  clearAllData();
}